import React, { useEffect, useState } from 'react'
import { Badge, Button, Col, Empty, Row, Space, Statistic, Switch, Tabs, Tooltip, message } from 'antd'
import { DetailDrawer } from 'Components/common/MainLayout'
import { PrimaryButton, SecondaryButton } from 'Components/button'
import styled from 'styled-components'
import { ProductOptions, CreateReq, MultiUom } from 'Store/product/types'
import { AppInput, LabelItem, UploadForm } from 'Components/form'
import { cloneDeep, trim } from 'lodash'
import {
  formValidation,
  isASCII,
  isFormDisabled,
  isFormError,
  isFormRequired,
  numberWithComma,
  roundNumber,
} from 'helpers/format'
import ChoosePhotosModal from './ChoosePhotosModal'
import theme, { MyTheme } from 'Components/common/Theme'
import { connect, useDispatch } from 'react-redux'
import { selectDatas } from 'Store/config/selector'
import RootState from 'typings/RootState'
import { getLatestGrnAPI } from 'Store/grn/api'
import { selectCurrentUser } from 'Store/user/selector'
import { LatestGrnReq } from 'Store/grn/types'
import { selectLatestGrn } from 'Store/grn/selector'
import { InfoCircleOutlined, InfoCircleTwoTone, PlusCircleFilled } from '@ant-design/icons'
import LinkText from 'Components/text/LinkText'
import { AlertInfo } from 'Components/alert'
import { themeConfig } from 'config'
import { TutoriaProductPage } from 'helpers/tutorials'
import { AppTutorial } from 'Components/utilities'
import MultiUomForm from './MultiUom'
import { DefaultStatus } from 'helpers/constanst'
import { Theme } from 'Components/common'
import { getStaffPermission } from 'helpers/account'
const { TabPane } = Tabs

type Props = {
  productInfo?: CreateReq
  data?: ProductOptions
  isShow: boolean
  onClose: () => void
  onSave: (data: ProductOptions) => void
  token?: string
  onAddProductImage?: (file: string[]) => void
  disableInput?: boolean
  uom: string
} & ReduxProps

const SpecialProductOptionDrawer = (props: Props) => {
  const {
    data,
    isShow,
    onClose,
    onSave,
    productInfo,
    token,
    onAddProductImage = () => {},
    disableInput = false,
    configs,
    currentUser,
    latestGrn,
    uom,
  } = props

  const priceLabel = configs?.value.price_labels || []
  const productID = productInfo?.id || 0
  const isFranchise = currentUser?.activeMerchant?.is_fc === true
  const enableProductOnline = themeConfig?.component?.elementOnlineProduct

  const requireFeild = ['title', 'price', 'weight', 'offline_price']
  const disableFirstUpdate = ['title', 'detail', 'width', 'height', 'depth', 'length', 'area', 'photo']
  const disableFranchise = [
    'title',
    'detail',
    'width',
    'height',
    'depth',
    'length',
    'area',
    'photo',
    'weight',
    'status',
  ]
  const initForm = {
    title: '',
    area: 0,
    barcode: '',
    depth: 0,
    discount: 0,
    height: 0,
    length: 0,
    photo: '',
    price: 0,
    publish: true,
    quantity: 0,
    total: 0,
    total_amount: 0,
    total_discount: 0,
    weight: enableProductOnline ? 0 : 1,
    width: 0,
    price_a: 0,
    price_b: 0,
    price_c: 0,
    online_percentage: 0,
    offline_price: 0,
  } as ProductOptions
  const [formData, setFormData] = useState(cloneDeep(initForm))
  const [activeTab, setActiveTab] = useState('1' as string)
  const [formError, setFormError] = useState([] as string[])
  const [chooseImage, setChooseImage] = useState(false)
  const isEdit = formData?.id
  const title = isEdit ? 'แก้ไขตัวเลือกสินค้า' : 'เพิ่มตัวเลือกสินค้าใหม่'

  // tutorial
  const [showTutorial, setShowTutorial] = useState(false as boolean)
  const steps = TutoriaProductPage.productOptions.steps
  const enableTutorial = TutoriaProductPage.productOptions.enable

  const [multiUoms, setMultiUoms] = useState([] as MultiUom[])
  const hasMainUom = uom !== ''
  const permission = getStaffPermission()
  const hasMultiUomPermission = permission && permission.includes('product-uoms')

  const dispatch = useDispatch()

  const onGetLatestGrn = (): void => {
    const req: LatestGrnReq = {
      product_id: productID,
      product_option_id: formData?.id || 0,
    }
    dispatch(getLatestGrnAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const validateForm = () => {
    const error = formValidation(requireFeild, formData)
    if (formData.barcode !== '') {
      const isAscii = isASCII(formData.barcode)
      if (!isAscii) {
        error.push('barcode_format')
      }
    }

    setFormError([...error])
    return error.length > 0 ? false : true
  }

  console.log('setFormData', formData)

  useEffect(() => {
    if (isShow && data) {
      const uoms = data?.uoms || []
      const findMaster = uoms?.filter(item => item.is_master)
      const form = {
        ...cloneDeep(initForm),
        ...data,
        purchase_price: (findMaster && findMaster[0]?.purchase_price) || 0,
      } as ProductOptions
      const filterMaster = uoms?.filter(item => !item.is_master)
      setMultiUoms([...filterMaster])
      setFormData({ ...form })
    }
    return () => {
      setFormData(cloneDeep(initForm))
      setFormError([])
      setMultiUoms([])
      setActiveTab('1')
    }
  }, [isShow, data])

  useEffect(() => {
    if (formError.length > 0) {
      validateForm()
    }
  }, [formData])

  useEffect(() => {
    if (formData?.id && productInfo?.id) {
      onGetLatestGrn()
    }
  }, [formData?.id, productInfo?.id])

  const isRequired = (name: string) => {
    return isFormRequired(requireFeild, name)
  }

  const isError = (name: string) => {
    return isFormError(formError, name)
  }

  const isDisabled = (name: string) => {
    return (
      (disableInput && isFormDisabled(isFranchise ? disableFranchise : disableFirstUpdate, name)) || false
    )
  }

  const decimalCount = (num: number) => {
    // Convert to String
    const numStr = String(num)
    // String Contains Decimal
    if (numStr.includes('.')) {
      return numStr.split('.')[1].length
    }
    // String Does Not Contain Decimal
    return 0
  }

  const onUpdateUoms = (uom: MultiUom, index: number) => {
    const data = cloneDeep(multiUoms) as MultiUom[]
    data[index] = uom

    setMultiUoms([...data])
  }

  const onDeleteUom = (removeIndex: number) => {
    const newUoms = multiUoms && multiUoms.filter((item, index) => index != removeIndex)
    setMultiUoms([...newUoms])
    message.success('ลบหน่วยสินค้าสำเร็จ!')
  }

  const onUpdateData = (val: any, key: string) => {
    let newVal = cloneDeep(val)
    if (
      key === 'price' ||
      key === 'offline_price' ||
      key === 'price_a' ||
      key === 'price_b' ||
      key === 'price_c'
    ) {
      const count = decimalCount(val)
      if (count > 2) return
    }

    if (key === 'online_percentage') {
      newVal = parseInt(val)
      if (newVal > 100) {
        newVal = 100
      }
    }

    setFormData({
      ...formData,
      [key]: newVal,
    })
  }

  const onUpdatePrice = (val: any) => {
    const newVal = cloneDeep(val)
    const count = decimalCount(val)
    if (count > 2) return

    setFormData({
      ...formData,
      price: newVal,
      offline_price: newVal,
    })
  }

  const getMultiUoms = () => {
    const findMaster = data?.uoms?.filter(item => item.is_master)
    const master = {
      barcode: formData?.barcode,
      multiplier: 1,
      offline_price: formData?.offline_price || 0,
      price: formData?.price || 0,
      price_a: formData?.price_a || 0,
      price_b: formData?.price_b || 0,
      price_c: formData?.price_c || 0,
      purchase_price: formData?.purchase_price || 0,
      status: DefaultStatus.ACTIVE,
      uom_name: uom,
      id: (findMaster && findMaster[0].id) || 0,
      is_master: true,
      is_default: true,
    } as MultiUom
    const uoms = multiUoms.map(item => {
      item.price = item.offline_price
      return item
    })
    return [master, ...uoms]
  }

  const validateMultiUomsForm = () => {
    let isValid = true
    multiUoms &&
      multiUoms.forEach(item => {
        if (trim(item.uom_name) == '' || item.multiplier < 2 || item.offline_price <= 0) {
          isValid = false
        }
      })
    return isValid
  }

  const onClickSave = (): void => {
    if (!validateForm()) {
      message.error('กรุณาระบุข้อมูลสินค้าให้ถูกต้อง')
      return
    }
    if (!validateMultiUomsForm()) {
      message.error('กรุณาระบุข้อมูล หน่วยอื่นๆของสินค้าให้ถูกต้อง')
      return
    }
    formData.uoms = getMultiUoms()
    console.log('formData', formData)
    onSave(formData)
  }

  const openModalChooseImage = () => {
    setChooseImage(true)
  }

  const closeModalChooseImage = () => {
    setChooseImage(false)
  }

  const onClickChooseImage = (): void => {
    openModalChooseImage()
  }

  const onConfirmChooseImage = (url: string): void => {
    onUpdateData(url, 'photo')
    setChooseImage(false)
  }

  const onUploadNewImage = (file: string[]): void => {
    onAddProductImage(file)
  }

  const getConfigName = (key: string): string => {
    const result = priceLabel && priceLabel.find(item => item.name === key)
    return `${result?.value || ''} ${result?.description ? '(' + result?.description + ')' : ''}`
  }

  const footer = (
    <Space size="middle" align="baseline">
      <PrimaryButton text="ยกเลิก" btnType="Cancel" onClick={onClose} />
      <PrimaryButton text="บันทึก" onClick={onClickSave} className="ttr-productoptions-save" />
    </Space>
  )

  const description = () => {
    return (
      <Row gutter={[8, 8]}>
        <Col md={14} xs={24}>
          <Space direction="vertical" size="small">
            <Badge
              color={theme.colors.primary}
              text={`ราคาต้นทุน/ต่อหน่วย ที่รับเข้าล่าสุด = ${numberWithComma(
                latestGrn?.grn_item?.cost,
                true,
              )} บาท`}
            />

            <Badge
              color={theme.colors.primary}
              text={`ต้นทุนแฝง ที่รับเข้าล่าสุด = ${numberWithComma(
                latestGrn?.grn_item?.hidden_cost,
                true,
              )} บาท`}
              //text="ต้นทุนแฝง ที่รับเข้าล่าสุด = 1,050.00 บาท"
            />
          </Space>
        </Col>
        <Col md={10} xs={24}>
          <Space direction="vertical" size="small">
            <Badge
              color={theme.colors.primary}
              text={`ราคาต้นทุน = ${numberWithComma(latestGrn?.grn_item?.average_cost, true)} บาท`}
            />
            <Badge
              color={theme.colors.primary}
              text={`ต้นทุนเฉลี่ย = ${numberWithComma(latestGrn?.total_average_cost, true)} บาท`}
            />
          </Space>
        </Col>
      </Row>
    )
  }

  const renderTooltip = (title: any) => {
    return (
      <StockWrapper>
        <Tooltip title={title} placement="right">
          {' '}
          <InfoCircleOutlined />
        </Tooltip>
      </StockWrapper>
    )
  }

  const onAddMultiUom = () => {
    if (!hasMainUom) {
      message.error('กรุณาเลือก "หน่วยสินค้าหลัก" ของสินค้าก่อน จึงจะสามารถเพิ่มหน่วยสินค้าอื่นได้')
      return
    }
    const initForm = {
      offline_price: 0,
      price_a: 0,
      price_b: 0,
      price_c: 0,
      uom_name: '',
      multiplier: 0,
      barcode: '',
      price: 0,
      purchase_price: 0,
      id: 0,
      status: DefaultStatus.ACTIVE,
    } as MultiUom
    const newFormUom = cloneDeep(multiUoms)
    newFormUom.push(initForm)
    setMultiUoms(newFormUom)
  }

  const MAX_UOMS = 10

  const MultiUomContent = (
    <Row gutter={[12, 12]} justify="center">
      <Col span={24}>
        <Row justify="space-between" gutter={[12, 12]}>
          <Col>
            <TextRemark>สินค้าที่มีการขายมากกว่า 1 หน่วยนับ เช่น ขายออกเป็น ชิ้น โหล แพ็ค</TextRemark>
            <br />
          </Col>
          {/* <Col>
            <Button
              type="link"
              icon={<PlusCircleFilled />}
              size="small"
              onClick={onAddMultiUom}
              disabled={multiUoms.length >= MAX_UOMS}
            >
              เพิ่มหน่วยสินค้า ({multiUoms.length}/{MAX_UOMS})
            </Button>
          </Col> */}
        </Row>
      </Col>
      {multiUoms && multiUoms.length > 0 ? (
        multiUoms.map((form, index) => {
          return (
            <Col span={24} key={index}>
              <MultiUomForm
                formData={form}
                onUpdate={data => onUpdateUoms(data, index)}
                onDelete={() => onDeleteUom(index)}
                getConfigName={getConfigName}
                index={index}
                mainUom={uom}
              />
            </Col>
          )
        })
      ) : (
        <Col span={24}>
          <Empty />
        </Col>
      )}
      <Col>
        <PrimaryButton
          text={`เพิ่มหน่วยสินค้าอื่น (${multiUoms.length}/${MAX_UOMS})`}
          icon={<PlusCircleFilled />}
          onClick={onAddMultiUom}
          disabled={multiUoms.length >= MAX_UOMS}
        />
      </Col>
    </Row>
  )

  const QuantityInput = (
    <AppInput
      name="quantity"
      label="สต๊อก"
      labelIcon={renderTooltip(
        <Space direction="vertical">
          <TextRemark>
            แพ็คเก็จปัจจุบันที่คุณใช้ หลังจากออกใบสั่งซื้อและรับสินค้าเข้าคลัง
            สต๊อกจะถูกปรับให้อัตโนมัติระหว่างสต๊อกขายออนไลน์ และสต๊อกขายออฟไลน์
          </TextRemark>
          <TextRemark>
            หากคุณต้องการปรับจำนวนสินค้าโดยไม่ผ่านกระบวนการรับสินค้าเข้าคลังให้ไปยังเมนู
            &quot;คลังสินค้า&quot; และปรับจำนวนสินค้า
          </TextRemark>
        </Space>,
      )}
      type="number"
      isRequired={isRequired('quantity')}
      isError={isError('quantity')}
      value={formData.quantity + (formData?.quantity_offline || 0)}
      onChange={onUpdateData}
      resProps={{ disabled: true }}
    />
  )

  const TitleInput = (
    <AppInput
      name="title"
      label="ชื่อสินค้า"
      isRequired={isRequired('title')}
      isError={isError('title')}
      value={formData.title}
      onChange={onUpdateData}
      resProps={{ disabled: isDisabled('title') }}
    />
  )

  const BarcodeInput = (
    <AppInput
      name="barcode"
      label="​Barcode"
      isRequired={isRequired('barcode')}
      specialRequired={formData.barcode !== ''}
      isError={isError('barcode') || isError('barcode_format')}
      errorMsg={isError('barcode_format') ? 'รูปแบบ Barcode ให้ถูกต้อง' : 'กรุณาระบุ Barcode'}
      value={formData.barcode}
      onChange={onUpdateData}
      resProps={{ disabled: isDisabled('barcode') }}
      labelIcon={
        <Tooltip title="Barcode รองรับชุดตัวอักษร 128 ASCII (ไม่รองรับภาษาไทย)">
          &nbsp; <InfoCircleOutlined />
        </Tooltip>
      }
    />
  )

  const LastGrnInfo = (
    <Description>
      <AlertInfo
        message={
          latestGrn && isEdit
            ? `ข้อมูลต้นทุนและราคาเฉลี่ยของสินค้าที่รับเข้าคลังล่าสุด`
            : 'ไม่พบข้อมูล ต้นทุนและราคาเฉลี่ยของสินค้าที่รับเข้าคลังล่าสุด'
        }
        description={latestGrn && isEdit ? description() : ''}
        banner
      />
    </Description>
  )

  const PurchasePriceInput = (
    <AppInput
      name="purchase_price"
      label="ราคาซื้อ"
      isRequired={isRequired('purchase_price')}
      isError={isError('purchase_price')}
      value={formData.purchase_price}
      onChange={onUpdateData}
      type="number"
      resProps={{ suffix: 'บาท' }}
      labelIcon={renderTooltip(
        <TextRemark>
          ราคาซื้อคืออะไร ? <br />
          คือข้อมูลที่บันทึกไว้สำหรับเป็นค่า default (ค่าเริ่มต้น) ของต้นทุนของสินค้าในการออกใบจัดซื้อ
        </TextRemark>,
      )}
    />
  )

  const EnableOnlineProductForm = (
    <>
      <Col span={24}>
        <Row gutter={[8, 8]} className="ttr-productoption-info">
          <Col md={8} xs={24}>
            {TitleInput}
          </Col>
          {/* <Col md={8} xs={24}>
            <AppInput
              name="weight"
              label="น้ำหนัก"
              type="number"
              isRequired={isRequired('weight')}
              isError={isError('weight')}
              value={roundNumber(formData.weight)}
              onChange={onUpdateData}
              resProps={{ disabled: isDisabled('weight'), suffix: 'กก.' }}
            />
          </Col> */}
          <Col md={8} xs={24}>
            {BarcodeInput}
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Row gutter={[8, 8]} className="ttr-productoption-price">
          <Col md={24} xs={24}>
            <Title> ข้อมูลราคาและสต๊อกสินค้า </Title>
          </Col>
          <Col md={24} xs={24}>
            {LastGrnInfo}
          </Col>
          <Col md={24} xs={24}>
            <Row justify="start" gutter={[8, 8]}>
              {/* <Col md={8} xs={24}>
                {QuantityInput}
              </Col> */}
              <Col md={8} xs={24}>
                <AppInput
                  name="weight"
                  label="น้ำหนัก"
                  type="number"
                  isRequired={isRequired('weight')}
                  isError={isError('weight')}
                  value={roundNumber(formData.weight)}
                  onChange={onUpdateData}
                  resProps={{ disabled: isDisabled('weight'), suffix: 'กก.' }}
                  labelIcon={renderTooltip(
                    <Space direction="vertical">
                      <TextRemark>
                        น้ำหนักสินค้าใช้สำหรับคำนวนค่าขนส่งสาธารณะ กรณีสินค้านี้เปิดใช้งานของบนระบบออนไลน์ผ่าน
                        App/Web {themeConfig.title.appName}
                      </TextRemark>
                    </Space>,
                  )}
                />
              </Col>
              <Col md={8} xs={24}>
                <AppInput
                  name="online_percentage"
                  label="เปอร์เซ็นต์ขายบนสต๊อกออนไลน์ (%)"
                  isRequired={isRequired('online_percentage')}
                  isError={isError('online_percentage')}
                  value={formData.online_percentage}
                  onChange={onUpdateData}
                  type="number"
                  resProps={{ suffix: '%' }}
                  labelIcon={renderTooltip(
                    <Space direction="vertical">
                      <TextRemark>
                        คือ จำนวนสต๊อก(เป็น %) ที่ร้านค้าต้องการแบ่งจำนวนสินค้าที่จะขายไปยังระบบออนไลน์
                      </TextRemark>
                      <TextRemark>ระบบออนไลน์ คือ ขายผ่าน App/Web {themeConfig.title.appName}</TextRemark>
                    </Space>,
                  )}
                />
              </Col>
              <Col md={8} xs={24}></Col>
              <Col md={8} xs={24}>
                <AppInput
                  name="price"
                  label="ราคาขายออนไลน์"
                  type="number"
                  isRequired={isRequired('price')}
                  isError={isError('price')}
                  value={formData.price}
                  onChange={onUpdateData}
                  resProps={{ disabled: isDisabled('price'), suffix: 'บาท' }}
                  labelIcon={renderTooltip(
                    <TextRemark>
                      ราคาขายออนไลน์ คือ ราคาสินค้าที่ขายบนระบบออนไลน์ (ขายผ่าน App/Web{' '}
                      {themeConfig.title.appName})
                    </TextRemark>,
                  )}
                />
              </Col>
              <Col md={8} xs={24}>
                <AppInput
                  name="offline_price"
                  label="ราคาขายหน้าร้าน"
                  isRequired={isRequired('offline_price')}
                  isError={isError('offline_price')}
                  value={formData.offline_price}
                  onChange={onUpdateData}
                  type="number"
                  resProps={{ suffix: 'บาท' }}
                  labelIcon={renderTooltip(
                    <TextRemark>ราคาขายหน้าร้าน คือ ราคาสินค้าที่ขายผ่านระบบ Terminal</TextRemark>,
                  )}
                />
              </Col>
              <Col md={8} xs={24}>
                {PurchasePriceInput}
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </>
  )

  const DisableOnlineProductForm = (
    <>
      <Col span={24}>
        <Row gutter={[8, 8]} className="ttr-productoption-info">
          <Col md={8} xs={24}>
            {TitleInput}
          </Col>
          <Col md={8} xs={24}>
            {BarcodeInput}
          </Col>
          {/* <Col md={8} xs={24}>
            {QuantityInput}
          </Col> */}
        </Row>
      </Col>
      <Col span={24}>
        <Row gutter={[8, 8]} className="ttr-productoption-price">
          <Col md={24} xs={24}>
            <Title> ข้อมูลราคาและสต๊อกสินค้า </Title>
          </Col>
          <Col md={24} xs={24}>
            {LastGrnInfo}
          </Col>
          <Col md={24} xs={24}>
            <Row justify="start" gutter={[8, 8]}>
              <Col md={8} xs={24}>
                <AppInput
                  name="offline_price"
                  label="ราคาขายหน้าร้าน"
                  isRequired={isRequired('offline_price')}
                  isError={isError('offline_price')}
                  value={formData.offline_price}
                  onChange={onUpdatePrice}
                  type="number"
                  resProps={{ suffix: 'บาท' }}
                  labelIcon={renderTooltip(
                    <TextRemark>ราคาขายหน้าร้าน คือ ราคาสินค้าที่ขายผ่านระบบ Terminal</TextRemark>,
                  )}
                />
              </Col>
              <Col md={8} xs={24}>
                {PurchasePriceInput}
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </>
  )

  const RequireData = (
    <Row gutter={[8, 8]}>
      {enableProductOnline ? EnableOnlineProductForm : DisableOnlineProductForm}
      <Col md={24} xs={24} className="ttr-productoption-price-special">
        <Row justify="space-between" align="middle">
          <Col>
            <SmallTitle>ราคาอื่นๆเพิ่มเติม (ใช้สำหรับระบบขายราคาพิเศษ) </SmallTitle>
          </Col>
          <Col>
            <a href="/purchase-setting" target="_bank">
              <Link>กำหนดรูปแบบราคาสินค้า</Link>
            </a>
          </Col>
        </Row>
        <Row gutter={[8, 8]}>
          <Col md={8} xs={24}>
            <AppInput
              name="price_a"
              label={getConfigName('price_a')}
              isRequired={isRequired('price_a')}
              isError={isError('price_a')}
              value={formData.price_a}
              onChange={onUpdateData}
              type="number"
              resProps={{ suffix: 'บาท' }}
            />
          </Col>
          <Col md={8} xs={24}>
            <AppInput
              name="price_b"
              label={getConfigName('price_b')}
              isRequired={isRequired('price_b')}
              isError={isError('price_b')}
              value={formData.price_b}
              onChange={onUpdateData}
              type="number"
              resProps={{ suffix: 'บาท' }}
            />
          </Col>
          <Col md={8} xs={24}>
            <AppInput
              name="price_c"
              label={getConfigName('price_c')}
              isRequired={isRequired('price_c')}
              isError={isError('price_c')}
              value={formData.price_c}
              onChange={onUpdateData}
              type="number"
              resProps={{ suffix: 'บาท' }}
            />
          </Col>
        </Row>
      </Col>
      <Col md={24} xs={24} className="ttr-productoption-status">
        <SwitchStyled>
          <Switch
            checked={formData.publish}
            onChange={(val: boolean) => onUpdateData(val, 'publish')}
            disabled={isDisabled('status')}
          />
          &nbsp; &nbsp;
          <LabelItem label={`สถานะสินค้า : ${formData.publish ? 'เปิดใช้งาน' : 'ปิดใช้งาน'}`} />
        </SwitchStyled>
      </Col>
    </Row>
  )

  const OptionData = (
    <Row gutter={[8, 8]}>
      <Col md={12} xs={24}>
        <AppInput
          name="width"
          label="ความกว้าง"
          type="number"
          isRequired={isRequired('width')}
          isError={isError('width')}
          value={roundNumber(formData.width)}
          onChange={onUpdateData}
          resProps={{ disabled: isDisabled('width'), suffix: 'ซม.' }}
        />
      </Col>
      <Col md={12} xs={24}>
        <AppInput
          name="height"
          label="ความสูง"
          type="number"
          isRequired={isRequired('height')}
          isError={isError('height')}
          value={roundNumber(formData.height)}
          onChange={onUpdateData}
          resProps={{ disabled: isDisabled('height'), suffix: 'ซม.' }}
        />
      </Col>
      <Col md={12} xs={24}>
        <AppInput
          name="depth"
          label="ความลึก"
          type="number"
          isRequired={isRequired('depth')}
          isError={isError('depth')}
          value={roundNumber(formData.depth)}
          onChange={onUpdateData}
          resProps={{ disabled: isDisabled('depth'), suffix: 'ซม.' }}
        />
      </Col>
      <Col md={12} xs={24}>
        <AppInput
          name="length"
          label="ความยาว"
          type="number"
          isRequired={isRequired('length')}
          isError={isError('length')}
          value={roundNumber(formData.length)}
          onChange={onUpdateData}
          resProps={{ disabled: isDisabled('length'), suffix: 'ซม.' }}
        />
      </Col>
      <Col md={12} xs={24}>
        <AppInput
          name="area"
          label="พื้นที่"
          type="number"
          isRequired={isRequired('area')}
          isError={isError('area')}
          value={roundNumber(formData.area)}
          onChange={onUpdateData}
          resProps={{ disabled: isDisabled('area'), suffix: 'ตรม.' }}
        />
      </Col>
    </Row>
  )

  const renderTab = () => {
    return (
      <Tabs defaultActiveKey="1" tabPosition="top" activeKey={activeTab} onChange={setActiveTab}>
        <TabPane tab="ข้อมูลสินค้า (หน่วยสินค้าหลัก)" key="1">
          {RequireData}
        </TabPane>
        {hasMultiUomPermission && productInfo?.bom !== 1 && (
          <TabPane
            tab={
              <div>
                หน่วยสินค้าอื่น{' '}
                <Badge count={multiUoms.length} style={{ backgroundColor: theme.colors.primary }}></Badge>
              </div>
            }
            key="3"
          >
            {MultiUomContent}
          </TabPane>
        )}

        <TabPane tab="รายละเอียดเพิ่มเติม" key="2">
          {OptionData}
        </TabPane>
      </Tabs>
    )
  }

  const valStyle = {
    //color: Theme.colors.primary,
    fontFamily: Theme.fontFamily.regular,
    //fontSize: Theme.typography.h4,
  }

  return (
    <DetailDrawer
      title={title}
      width={'70%'}
      onCloseDrawer={onClose}
      visible={isShow}
      //visible={true}
      footer={footer}
      isShowTutorial={showTutorial}
      showTutorial={enableTutorial}
      onClickStart={() => setShowTutorial(true)}
    >
      <ChoosePhotosModal
        isShow={chooseImage}
        onClose={closeModalChooseImage}
        onSelectFile={onConfirmChooseImage}
        onUpdateData={onUploadNewImage}
        productPhotos={productInfo?.photos || []}
        token={token}
        key="ChoosePhotosModal"
      />
      <Row align="top" className="ttr-productoption-img">
        {!formData.photo && (
          <Col md={12} xs={24}>
            <LabelItem label={`รูปภาพสินค้า`} /> <br />
            <AddImage type="dashed" onClick={onClickChooseImage} disabled={isDisabled('photo')}>
              เลือกรูปภาพ
            </AddImage>
          </Col>
        )}
        {formData.photo && (
          <Col md={12} xs={24}>
            <UploadForm
              token={''}
              onUpdateData={onUpdateData}
              currentFile={formData.photo}
              folder="photo"
              listType="picture-card"
              isPrivate={true}
              acceptType="image/png,image/jpeg"
              withCropImage={true}
              aspect={2.59898477157}
              name="photo"
              description=""
              isRequired={isRequired('photo')}
              isError={isError('photo')}
              label="รูปภาพสินค้า"
              key="photo-product-options"
              readOnly={isDisabled('photo')}
            />
          </Col>
        )}
        <Col md={12} xs={24}>
          <Statistic
            title={
              <Space>
                <span>
                  สต๊อกคงเหลือ{' '}
                  {renderTooltip(
                    <Space direction="vertical">
                      <TextRemark>
                        <TextBold>การเพิ่มสินค้าเข้าสต๊อก</TextBold> หากคุณต้องการเพิ่มสินค้าเข้าสต๊อก
                        ให้ไปยังเมนู &quot;ระบบจัดซื้อ&quot;
                        โดยการสร้างใบสั่งซื้อสินค้าและเลือกสินค้าที่ต้องการ จากนั้นกดรับสินค้าเข้าคลัง
                        สต๊อกก็จะเพิ่มให้ตามจำนวนที่ระบุ
                      </TextRemark>
                      <TextRemark>
                        <TextBold>การลดจำนวนสินค้าในสต๊อก</TextBold>{' '}
                        หากคุณต้องการปรับจำนวนสินค้าออกจากสต๊อกสินค้า ให้ไปยังเมนู &quot;คลังสินค้า&quot;
                        และปรับจำนวนสินค้า
                      </TextRemark>
                    </Space>,
                  )}
                </span>
              </Space>
            }
            value={formData.quantity + (formData?.quantity_offline || 0)}
            suffix={uom}
            valueStyle={valStyle}
          />
        </Col>
      </Row>
      {renderTab()}
      {enableTutorial && (
        <AppTutorial
          onCloaseTutorial={() => setShowTutorial(false)}
          showTutorial={showTutorial}
          steps={steps}
        />
      )}
    </DetailDrawer>
  )
}

const SwitchStyled = styled.div`
  margin: 10px 0;
`
const AddImage = styled(Button)`
  margin-top: 5px;
  margin-bottom: 20px;
  width: 102px;
  height: 102px;
  font-size: 12px;
`

const StockWrapper = styled.span`
  padding: 0 2px;
`

const TextRemark = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const Title = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  margin-bottom: 10px;
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
`

const Description = styled.div`
  .ant-descriptions-title {
    font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  }
 //background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
  padding: 5px 0;
  margin-bottom: 10px;
  th,
  td,
  span {
    font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  }
`

const Link: any = styled(LinkText)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const HeaderForm = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const SmallTitle = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  margin-bottom: 10px;
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const TextBold = styled.span`
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
`

const mapStateToProps = (state: RootState) => {
  return {
    configs: selectDatas(state),
    currentUser: selectCurrentUser(state),
    latestGrn: selectLatestGrn(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(SpecialProductOptionDrawer)
